import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IAttachmentMediaBadgeProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import Text from "../../../text";

const AttachmentMediaBadge: FC<IAttachmentMediaBadgeProps> = ({
    customTheme,
    children,
    style,
    ...props
}) => {
    const {
        shapeConfigs,
        typography,
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        shapeConfigs,
        typography,
        radiuses,
        colors,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        <Text
            customColor={colors.system.onInverse.neutral}
            customTheme={customTheme}
            variant="labelSmallSize"
        >
            {children}
        </Text>
    </View>;
};
export default AttachmentMediaBadge;
